// Smart Sash Admin Panel - User Permission Service
// User permission management operations (v2 API)

import { axiosClient } from '../http/axiosClient';
import { PermissionDTO } from '@/models';

const permissionPath = (institutionId: string, userId: string) =>
  `/institutions/${institutionId}/users/${userId}/permissions`;

/**
 * User Permission Service (v2)
 */
export const userPermissionService = {
  /**
   * Get user's permissions
   */
  getUserPermissions: async (institutionId: string, userId: string): Promise<PermissionDTO[]> => {
    const response = await axiosClient.get<PermissionDTO[]>(permissionPath(institutionId, userId));
    return response.data;
  },

  /**
   * Replace all user permissions (PUT - full replace)
   */
  replaceUserPermissions: async (
    institutionId: string,
    userId: string,
    permissionIds: string[]
  ): Promise<PermissionDTO[]> => {
    const response = await axiosClient.put<PermissionDTO[]>(
      permissionPath(institutionId, userId),
      permissionIds
    );
    return response.data;
  },

  /**
   * Add permissions without removing existing ones
   */
  addUserPermissions: async (
    institutionId: string,
    userId: string,
    permissionIds: string[]
  ): Promise<PermissionDTO[]> => {
    const response = await axiosClient.post<PermissionDTO[]>(
      permissionPath(institutionId, userId),
      permissionIds
    );
    return response.data;
  },

  /**
   * Assign a single permission
   */
  assignPermission: async (
    institutionId: string,
    userId: string,
    permissionId: string
  ): Promise<void> => {
    await axiosClient.post(`${permissionPath(institutionId, userId)}/${permissionId}`);
  },

  /**
   * Remove a single permission
   */
  removePermission: async (
    institutionId: string,
    userId: string,
    permissionId: string
  ): Promise<void> => {
    await axiosClient.delete(`${permissionPath(institutionId, userId)}/${permissionId}`);
  },
};

export default userPermissionService;
